import { render, staticRenderFns } from "./index_websocket.vue?vue&type=template&id=f184363e&scoped=true&"
import script from "./index_websocket.vue?vue&type=script&lang=js&"
export * from "./index_websocket.vue?vue&type=script&lang=js&"
import style0 from "./index_websocket.vue?vue&type=style&index=0&id=f184363e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f184363e",
  null
  
)

export default component.exports